export const selectPaymentsApprovedDelay = (state: RootState): number => state.payments.approvedDelay;
export const selectPaymentsApprovedWrongAmount = (state: RootState): number => state.payments.approvedWrongAmount;
